import {Link} from "react-router";

import Button from "@/components/button/Button";
import {useCheckoutContext} from "@/components/context/hooks.ts";
import {shortCurrency} from "@/lib/format.tsx";
import {CallToActionBlock} from "@/pages/billing/subscription-summary/CallToActionBlock.tsx";

interface ChangeToMonthlyProps {
  currentPlan: string;
}

export const ChangeToMonthly = ({currentPlan}: ChangeToMonthlyProps) => {
  const {billingAmount} = useCheckoutContext();
  const billAmount = billingAmount || 0;
  const subject = "Please downgrade my plan to monthly";
  const message = `Plan: ${currentPlan} - ${shortCurrency(billAmount, 2)}/yr`;
  return (
    <div>
      <h3 className="my-4 fs-5">Change Billing Period</h3>
      <CallToActionBlock text="To switch your billing cycle to monthly, please contact support">
        <Button as={Link} to={`/contact?subject=${subject}&message=${message}`}>
          Request Changes
        </Button>
      </CallToActionBlock>
    </div>
  );
};
